if(!customElements.get('pop-up')) {
  customElements.define('pop-up', class Popup extends HTMLElement {
    constructor() {
      super();
      
      this.cookieName = `stylescape:popup-${this.dataset.sectionId}`;
      this.showOnMobile = this.dataset.mobileHidden === "false";
      this.container = this.querySelector('.popup-container');
      this.overlay = this.querySelector('.popup-overlay'); 
      this.closeBtn = this.querySelector('.close-modal'); 
      this.overlay.addEventListener('click', this.hide.bind(this));
      this.closeBtn.addEventListener('click', this.hide.bind(this));
  
      window.addEventListener('resize', ()=>{
          if(window.innerWidth < 768 && !this.showOnMobile){
            this.hide();
          }else if(window.innerWidth >= 768){
            if (!window.getCookie(this.cookieName)) {
                setTimeout(() => this.show(), Number(this.dataset.delay) * 1000);  
            }
          }
      });
      
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target === this.closest('.shopify-section')) this.show();
        });
        document.addEventListener('shopify:section:deselect', this.hide.bind(this));
      }
      else if (!window.getCookie(this.cookieName)) {
          if(window.innerWidth < 768 && !this.showOnMobile) return;
          setTimeout(() => this.show(), Number(this.dataset.delay) * 1000);  
      }
  
    }
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      popup.classList.remove('hidden');
      this.setAttribute('open', '');
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
    hide() {
      const popup = this.querySelector('.template-popup');
      document.body.classList.remove('overflow-hidden');
      popup.classList.add('hidden');
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
      if(window.innerWidth < 768 && !this.showOnMobile) return
      window.setCookie(this.cookieName, true, this.dataset.expiry);
    }
  })
}
